import { styled } from 'baseui'

export const StyledNotification = styled('div', ({ $theme, $type, $boldText, $border }) => {
  const outputColour = {}
  let borderStyle = 'solid'

  switch ($type) {
    case 'negative':
      outputColour.text = $theme.colors.negative
      outputColour.bg = $theme.colors.negative150
      outputColour.shadow = $theme.colors.negative400
      break
    case 'info':
      outputColour.text = '#58595B'
      outputColour.bg = '#E9EEFB'
      outputColour.shadow = $theme.colors.primary400
      borderStyle = 'dashed'
      break
    case 'positive':
      outputColour.text = '#58595B'
      outputColour.bg = '#D1F8CB'
      outputColour.shadow = $theme.colors.positive400
      break
    case 'warning':
    case 'additionalSale':
      outputColour.text = $theme.colors.grey
      outputColour.bg = $theme.colors.warning150
      outputColour.shadow = $theme.colors.warning300
      borderStyle = 'dashed'
      break
    case 'script':
    case 'agentScript':
    default:
      outputColour.text = $theme.colors.grey
      outputColour.bg = $theme.colors.bg050
      outputColour.shadow = $theme.colors.primary400
      borderStyle = 'dashed'
      break
  }

  return {
    backgroundColor: outputColour.bg,
    color: outputColour.text,
    borderTopLeftRadius: $theme.borders.radius200,
    borderTopRightRadius: $theme.borders.radius200,
    borderBottomLeftRadius: $theme.borders.radius200,
    borderBottomRightRadius: $theme.borders.radius200,
    border: $border ? `1px ${borderStyle} ${outputColour.shadow}` : 'none',
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
    paddingLeft: '.5rem',
    paddingRight: '.5rem',
    ...$theme.typography.ParagraphXSmall,
    fontWeight: $boldText ? 'bold' : 'normal',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: '0.5rem',
  }
})

export const NotificationContent = styled('div', ({ $centerText }) => ({
  display: 'flex',
  justifyContent: $centerText ? 'center' : 'flex-start',
  width: '100%',
  gap: '.5rem',
}))

export const IconWrapper = styled('div', {
  flex: '0 0 auto',
})

export const TextWrapper = styled('div', ({ $theme, $centerText }) => ({
  display: 'flex',
  alignItems: 'center',
  ...$theme.typography.ParagraphSmall,
  flex: $centerText ? '0 0 auto' : '1 1 auto',
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  textAlign: $centerText ? 'center' : 'left',
  width: 'auto',
  letterSpacing: '-0.084px',
}))

export const NotificationActions = styled('div', ({ $theme }) => ({
  width: '100%',
  marginTop: $theme.sizing.scale400,
  display: 'flex',
}))
